import { configureStore } from '@reduxjs/toolkit';
import rootReducers from './rootReducer';
import storage from 'redux-persist/lib/storage';
import { encryptTransform } from 'redux-persist-transform-encrypt';
import {
  persistReducer,
  persistStore,
} from 'redux-persist'
import thunk from 'redux-thunk';
import config from '../utils/config';

const persistConfig = {
  key: 'state',
  storage: storage,
  transforms: [
    encryptTransform({
      secretKey: config.SECRET_KEY,
      onError: function (error) {
        // Handle encryption errors
        console.error('Error while encrypting data:', error);
      },
    }),
  ],
}

const persistedReducer = persistReducer(persistConfig, rootReducers)
const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: [thunk],
})
export const persistor = persistStore(store)
export default store;